import { useQuery } from '@tanstack/react-query';
import { StudentImage } from '../models';

export default function useAccessCodePersister({ accessCode, schoolId }) {
  return useQuery({
    queryKey: ['access code persister', accessCode, schoolId],
    queryFn: () => (
      StudentImage
        .where({ for_access_code_and_school: [accessCode, schoolId] })
        .per(1)
        .all()
        .then((res) => {
          if (res.data.length > 0) {
            localStorage.setItem(`currentSeason-${res.data[0].studentId}`, res.data[0].folder);
          }

          return res.data
        })
    ),
    enabled: !!(accessCode && schoolId),
  });
}
